module.exports = __webpack_public_path__ + "img/onderhoud.01f16981.jpg";